import React from 'react';
import classNames from 'classnames';
import {
    H1,
    H3,
    SectionHeading,
    Body,
} from '@chartbeat/light-side/lib/components';

import logoWithTitle from '../../images/logo-with-title.svg';
import stripes from '../../images/stripes.svg';

import styles from './slides.cssm';

export const SLIDES = [
  (
    <div>
        <img className={styles.titleLogo} src={logoWithTitle} />
        <div className={styles.titleContainer}>
            <h1 className={styles.title}>2016</h1>
            <div className={styles.stripes}><img src={stripes}/></div>
        </div>
        <h2 className={styles.subTitle}>
            The most engaging stories of the year
        </h2>
        <div className={classNames(styles.bodyText, styles.underMarker)}>
            <Body className={styles.intro}>What a year it was. The US Election and Brexit brought dramatic political change. Terror attacks and gun violence broke first as news and slowly turned into global despair. The Rio Olympics united the world as the infrastructure of the host city crumbled beneath its own weight. We witnessed storytelling evolve and engage our attention in unprecedented ways. 2016 shook us, but also reminded us that we live in societies where journalists have a voice and the freedom to write openly and without fear of reprisal.</Body>
            <Body>The following list contains the stories that defined the breadth, the depth, and the power of journalism in 2016.</Body>
        </div>
    </div>
  ),
  (
    <div>
        <h2 className={styles.subTitle}>
          How we made it happen
        </h2>
        <div className={classNames(styles.bodyContainer, styles.columns)}>
          <div className={classNames(styles.metrics, styles.col4)}>
            <div><H1>50,000</H1><SectionHeading>sites tracked</SectionHeading></div>
            <div><H1>46 million</H1><SectionHeading>pieces of content published</SectionHeading></div>
            <div><H1>2.5 billion</H1><SectionHeading>minutes of engaged time</SectionHeading></div>
          </div>
          <div className={classNames(styles.col2, styles.sideBar)}>
            <Body>Chartbeat is the content intelligence partner for more than 50,000 leading media sites across the globe. On each site, on every article and every page, we track what people are reading on a second-by-second, pixel-by-pixel basis. To make this cut is no small feat.</Body>
            <Body>The top stories of 2016 had the most Total Engaged Time – the total amount of time visitors spent actively reading pages – of any in our network. Different topics and different content types (breaking news vs. interactive experiences, for example) serve very different purposes, so we categorized each story by topic and content type so you could compare engagement on like-stories.</Body>
            <Body>We also included trend lines for each story (on a normalized scale from Jan to Dec – see example below) which shows the difference between a breaking news story and one that accumulated attention over time.</Body>
          </div>
        </div>
        <div className={styles.mockCard}><div /></div>
    </div>
  ),
  (
    <div>
        <div className={styles.backgroundImages}/>
        <h2 className={styles.subTitle}>Thanks</h2>
        <div className={classNames(styles.bodyContainer, styles.rows)}>
            <H3 className={styles.quoteBlock}>
                How does one story stand out in a sea of content?<br/><br/>
                The answer is as complex as it is simple.<br/>It has to be outstanding journalism.
            </H3>
            <div className={styles.bodyText}>
                <Body>To every publisher featured here and to those who will define 2017, thank you.</Body>
                <Body>It is not easy to find and share the truth and arm citizens with information, but it’s one of the most important jobs there is. Keep up the incredible work. You have our attention.</Body>
                <Body>- The Chartbeat team</Body>
            </div>
        </div>
    </div>
  ),
]



// WEBPACK FOOTER //
// ./src/containers/app/slides.js